import { useEffect, useState } from "react";
import classNames from "classnames";
import { useRouter } from "next/router";

import { useCookieDomain } from "hooks/useCookieDomain";
import { setCookie } from "utils/cookies";
import { availableStorage } from "utils/storage";
import { getUserAgent, userAgentIsGoogleBot } from "utils/userAgent";

import ClearIcon from "components/Icons/x.svg";

const COOKIE_SETTINGS_ADVERTISING = "acceptsAdvertisingCookies";
const VIEWED_COOKIE_CONSENT = "viewedCookieConsent";

// Cookie Banner is only based on local storage. Cookie is for backwards compatability.
const hasViewedBanner = () => {
  const storage = availableStorage();
  if (!storage) {
    return false;
  }

  return !!storage.getItem(VIEWED_COOKIE_CONSENT) || false;
};

export const CookiePopup = () => {
  // This logic is flipped to avoid a "flash" of the content
  const { query } = useRouter();
  const [hasNotViewedCookieBanner, setHasNotViewedCookieBanner] =
    useState(false);
  const cookieDomain = useCookieDomain();

  const acceptCookies = () => {
    const storage = availableStorage();
    if (storage) {
      storage.setItem(VIEWED_COOKIE_CONSENT, "true");
    }
    setCookie(COOKIE_SETTINGS_ADVERTISING, true, cookieDomain, 365);
    setHasNotViewedCookieBanner(false);
  };

  useEffect(() => {
    if (
      !userAgentIsGoogleBot(getUserAgent()) &&
      !query?.["disable_cookie_popup"]
    ) {
      setHasNotViewedCookieBanner(!hasViewedBanner());
    }
  }, []);

  return (
    <div
      id="cookie-banner"
      className={classNames(
        "bg-default rounded fixed text-xs z-header position-consent",
        {
          hidden: !hasNotViewedCookieBanner,
        }
      )}
    >
      <div className="pl-lg pt-lg pb-lg pr-xl">
        <p className="text-xs text-white pr-lg">
          We use cookies for certain features and to improve your experience.
          See our <a href="/info/privacy-policy#cookies">Cookie Policy</a>&nbsp;
          and <a href="/info/privacy-policy">Privacy Policy</a> to learn more
        </p>
        <button
          id="cookie-banner__dismiss"
          className="absolute m-sm right-0 text-white top-0"
          aria-label="Close privacy and cookie policy notice"
          onClick={acceptCookies}
        >
          <ClearIcon height="16" width="16" />
        </button>
      </div>
      <style jsx global>{`
        @media screen and (min-width: 768px) {
          .position-consent {
            bottom: 1rem;
            right: 1rem;
            width: 304px;
            height: 92px;
          }
        }

        @media screen and (max-width: 767px) {
          .position-consent {
            bottom: 0.5rem;
            left: 0.5rem;
            right: 0.5rem;
            height: 92px;
          }
        }

        #cookie-banner {
          z-index: 2147483647; /* max z index */
        }
      `}</style>
    </div>
  );
};

export default CookiePopup;
